import { gql } from "@apollo/client";

export const MenuQuery = gql`
  query menu {
    menu {
      items {
        label
        route
      }
    }
  }
`;
